<template>
  <div class="container-custom">
    <!-- breadscrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'Navigation',
          to: {
            name: 'Navigation'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'NavigationEdit',
            query: {
              section: $route.query.section,
            },
          }
        }
      ]"
    ></Breadscrumbs>
    <!-- page actions -->
    <div class="page-actions">
      <h2>編輯Navigation</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- block 1 -->
    <div class="block" style="height: 70vh; margin-bottom: 30px;">
      <PageMenu :sections="sections">
        <component :is="sectionView" :navigation="navigation"></component>
      </PageMenu>
    </div>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import HeaderNav from '@/views/B-2__Navigation/c/B-2-1-1a__NavigationEdit_Header-Nav.vue';
import SubNav from '@/views/B-2__Navigation/c/B-2-1-1b__NavigationEdit_Sub-nav.vue';
import FooterMenu from '@/views/B-2__Navigation/c/B-2-1-1c__NavigationEdit_Footer-Menu.vue';
// import FooterDisclaimer from '@/views/B-2__Navigation/c/B-2-1-1d.vue';
import SocialMedia from '@/views/B-2__Navigation/c/B-2-1-1e.vue';
import AboutNav from '@/views/B-2__Navigation/c/B-2-1f__NavigationEdit_About-Nav.vue';
import PageMenu from '@/components/PageMenu.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SupportNav from '@/views/B-2__Navigation/c/B-2-1g__NavigationEdit_Support-Nav.vue';
import EdmsNav from '@/views/B-2__Navigation/c/B-2-1g__NavigationEdit_Edms-Nav.vue';

export default {
  components: {
    HeaderNav,
    SubNav,
    FooterMenu,
    // FooterDisclaimer,
    SocialMedia,
    AboutNav,
    PageMenu,
    LangDialog,
    Breadscrumbs,
    SupportNav,
    EdmsNav,
  },
  data: () => ({
    isLangOpen: false,
    sections: [
      {
        name: 'Header-Nav',
        component: 'HeaderNav',
      },
      {
        name: 'Sub-Nav',
        component: 'SubNav',
      },
      {
        name: 'About Menu',
        component: 'AboutNav',
      },
      {
        name: 'Footer Menu',
        component: 'FooterMenu',
      },
      {
        name: 'Support Menu',
        component: 'SupportNav',
      },
      /* {
        name: 'Footer Disclaimer',
        component: 'FooterDisclaimer',
      }, */
      {
        name: 'Social Media',
        component: 'SocialMedia',
      },
      {
        name: 'Edms Nav',
        component: 'EdmsNav',
      },
    ],
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('navigation', ['navigation']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  created() {
    if (this.navigation === null) {
      this.getNavigations();
    }
  },
  methods: {
    ...mapActions('navigation', {
      getNavigations: 'find',
      save: 'save',
    }),
    toNavigation() {
      this.$router.push({
        name: 'Navigation',
        query: {
          section: this.$route.query.section,
        },
      });
    },
    cancelHandler() {
      this.toNavigation();
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.save(this.navigation).then(() => {
          this.toNavigation();
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
